// Calendar profile modal open/close helpers — registered via
// context.functions so any element can dispatch them with:
//   el.call('openProfileModal', email)
//   el.call('closeProfileModal')
//
// Migrated 2026-06-01 from `root.update({ profileEmail: email })` to a
// @symbo.ls/windows custom-template layer. `root.profileEmail` stays as
// the data carrier — chat hash-sync + the body's own reactive reads
// still pull from it. Only the visibility flag moves to the layer.

const PROFILE_LAYER_ID = 'cal-profile'

const _rootState = (el) =>
  el?.state?.root || el?.getRoot?.()?.state?.root || el?.getRoot?.()?.state || null

export function openProfileModal(email) {
  if (!email) return
  const root = _rootState(this)
  if (!root) return
  root.update({ profileEmail: email })
  // MODAL-X-OVERFLOW-1: openCustomModal supplies a safe default maxHeight
  // so the Close X can't be pushed off-screen by tall content / a short
  // viewport.
  this.call('openCustomModal', {
    id: PROFILE_LAYER_ID,
    content: { extends: 'CalProfileModal' }
  })
}

export function closeProfileModal() {
  const root = _rootState(this)
  // Mirrors the old `extraClose: { profileModalTab: 'profile' }` reset.
  root?.update({ profileEmail: null, profileModalTab: 'profile' })
  this.call('closeModal', PROFILE_LAYER_ID)
}
